// extracted by mini-css-extract-plugin
export default {"overlay":"Preloader_overlay__70wXg","wrapper":"Preloader_wrapper__auWiD","spinnerContent":"Preloader_spinnerContent__7O+Yc"};